import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
    constructor(
        public translate: TranslateService,
    ) {
        super();

        this.getAndInitTranslations();
    }

    getAndInitTranslations() {
        this.translate.get('GLOBAL.PAGINATOR').subscribe((paginator_text) => {
            this.itemsPerPageLabel = paginator_text;
            this.nextPageLabel = paginator_text;
            this.previousPageLabel = paginator_text;
        });
        this.changes.next();

    }

    getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
            return `0 / ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} / ${length}`;
    }
}